"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLUploadFile = void 0;
const typeorm_1 = require("typeorm");
const UploadFile_1 = require("./UploadFile");
let URLUploadFile = class URLUploadFile extends UploadFile_1.UploadFile {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.URLUploadFile = URLUploadFile;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], URLUploadFile.prototype, "url", void 0);
exports.URLUploadFile = URLUploadFile = __decorate([
    (0, typeorm_1.ChildEntity)('url'),
    __metadata("design:paramtypes", [Object])
], URLUploadFile);
